import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { UserDataService } from '../../../../shared/services/userData.service';
import { Icons } from '../../../../shared/helpers/icons';
import { ISchedule } from '../../../../shared/models/schedule';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ScheduleService } from '../../../../shared/services/schedule.service';
import { DateUtils } from '../../../../shared/helpers/dateUtils';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'training-exercise',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LucideAngularModule,
    NoEmojiDirective,
    NgxPaginationModule
  ],
  templateUrl: './training-exercise.component.html',
  styleUrl: './training-exercise.component.css'
})
export class TrainingExerciseComponent implements OnInit, OnDestroy  {
  fullSchedulesList: ISchedule[] = [];
  schedulesList: ISchedule[] = [];
  icons = Icons;
  currentBuildingId: string | null = null;

  searchQuery: string = '';
  currentSchedule: ISchedule | null = null;
  buildingId: string | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;
  message: string | null = null;
  page = 1;
  itemsPerPage = 10;
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';

  loading: boolean = false;
  sortOrder: boolean = true;
  showHistory: boolean = false;
  isSchoolYearDropdownOpen = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private userDataService: UserDataService,
    private scheduleService: ScheduleService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    document.addEventListener('click', this.handleClickOutside);
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();
    this.loadSchedules();
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.page = 1;
    this.loadSchedules();
  }

  loadSchedules(): void {
    if (this.currentBuildingId && this.selectedSchoolYear) {
      this.loading = true;
      this.scheduleService.getSchedules(this.currentBuildingId, this.selectedSchoolYear).subscribe({
        next: (response) => {
          this.loading = false;
          this.page = 1;
          console.log('Fetched schedules list:', response);
          if (!response.has_error) {
            this.fullSchedulesList = response.data ? response.data : [];
            this.schedulesList = [...this.fullSchedulesList];
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error fetching schedulesList:', error.message);
        }
      });
    }
  };

  sortList(key: keyof typeof this.schedulesList[0]): void {
    this.sortOrder = !this.sortOrder;
    this.schedulesList.sort((a, b) => {
      const valueA = a[key]?.toString().toLowerCase() || '';
      const valueB = b[key]?.toString().toLowerCase() || '';

      if (valueA < valueB) {
        return this.sortOrder ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }  

  filterSchedulesList(): void {
    const query = this.searchQuery.toLowerCase().trim();
  
    this.schedulesList = this.fullSchedulesList.filter((item) => {
      return (
        item.type_name.toLowerCase().includes(query) ||
        item.name?.toLowerCase().includes(query) ||
        item.last_updated_user_name?.toLowerCase().includes(query) ||
        item.last_updated_at?.toLowerCase().includes(query) ||
        item.duration?.toString().toLowerCase().includes(query)
      );
    });
  }

}
